import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { fromEvent as observableFromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { PartnerInfo } from '../core/partner';
import { PartnerService } from '../core/partner.service';
import { BillingSettingsService } from '../shared-billing/settings/billing-settings.service';
import { OmniSearchService } from './omni-search.service';

@Component({
  templateUrl: './partner-overview.component.html',
  styleUrls: ['./common.scss'],
})
export class PartnerOverviewComponent implements AfterViewInit {
  @ViewChild('searchTerm', { static: true }) searchTerm: ElementRef;
  partners$: Observable<PartnerInfo[]>;

  constructor(
    public dialogRef: MatDialogRef<PartnerOverviewComponent>,
    private partnerService: PartnerService,
    private omnisearchService: OmniSearchService,
    private router: Router,
    private billingSettingsService: BillingSettingsService,
  ) {}

  ngAfterViewInit(): void {
    this.partners$ = observableFromEvent(this.searchTerm.nativeElement, 'keyup').pipe(
      distinctUntilChanged(),
      map(() => {
        return this.searchTerm.nativeElement.value;
      }),
      debounceTime(300),
      switchMap((searchTerm) => this.partnerService.search(searchTerm)),
    );
  }

  goToOverview(partnerId: string): void {
    // This is a temporary fix around the billingSettingsService because previous values were displaying data for the newly swapped to partner
    // in our billing pages, which raises concerns. This is a hot fix until work is done to clean up that service.
    this.billingSettingsService.resetCache();
    this.router.navigate(['superadmin', 'contract', partnerId.toUpperCase(), 'overview']);
    this.dialogRef.close();
  }
}
